import { useMemo } from "react";
import { Link } from "react-router-dom";
import Storage from "../services/Storage";

const ClearSession = () => {
    const storage = useMemo(() => new Storage(), []);
    storage.remove("sso_token");
    return (
        <>
            <h2 className="m-4 text-center">
                Session cleared!
            </h2>
            <h5 className="text-center">
                <Link to="/">Click here to login</Link>
            </h5>
        </>
    );
}

export default ClearSession;